import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import HeaderImage from '../../img/programmers-header-reverse.svg'
import { Helmet } from 'react-helmet'

const _404 = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - 404</title>
            </Helmet>

            <header id='section-1'>
                <img src={HeaderImage} alt='' />
            </header>

            <section className='mt-5 pt-5 text-center'>
                <h1>صفحه مورد نظر یافت نشد 404</h1>
                <Link to='/'>
                    <button className='btn btn-primary mt-5 shadow' style={
                        {
                            background: '#00AD9F',
                            border: 'none',
                            padding: '0.5em 2em',
                        }
                    }>بازگشت به صفحه اصلی</button>
                </Link>
            </section>

        </>
    )
}

export default _404